export type Route =
  | 'dashboard'
  | 'analytics'
  | 'designer'
  | 'shipping-rates'
  | 'quantity-offers'
  | 'tracking'
  | 'settings';

export const ROUTE_TO_PATH: Record<Route, string> = {
  dashboard: '/',
  analytics: '/analytics',
  designer: '/designer',
  'shipping-rates': '/designer/shipping-rates',
  'quantity-offers': '/sales-booster/quantity-offers',
  tracking: '/tracking',
  settings: '/settings',
};

export function pathToRoute(pathname: string): Route {
  if (pathname.startsWith('/analytics')) return 'analytics';
  if (pathname.startsWith('/designer/shipping-rates')) return 'shipping-rates';
  if (pathname.startsWith('/designer')) return 'designer';
  if (pathname.startsWith('/sales-booster')) return 'quantity-offers';
  if (pathname.startsWith('/tracking')) return 'tracking';
  if (pathname.startsWith('/settings')) return 'settings';
  return 'dashboard';
}
